var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        { staticClass: "mr-2 ml-2", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _vm.formValues != {}
                ? _c(
                    "div",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-2",
                          attrs: { align: "center", "no-gutters": "" }
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-center",
                              attrs: { cols: "12", sm: "3", md: "2" }
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-light" },
                                [_vm._v("Tipo de tarea")]
                              )
                            ]
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "9", md: "10" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  attrs: {
                                    dense: "",
                                    rules: [_vm.rules.required()]
                                  },
                                  model: {
                                    value: _vm.task.person,
                                    callback: function($$v) {
                                      _vm.$set(_vm.task, "person", $$v)
                                    },
                                    expression: "task.person"
                                  }
                                },
                                _vm._l(_vm.formValues.taskTypes, function(
                                  type
                                ) {
                                  return _c(
                                    "div",
                                    { key: type.value },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          color: "#60BB46",
                                          label: type.description,
                                          value: type.value
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                { staticClass: "mr-2", attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    [
                      _c("v-textarea", {
                        attrs: {
                          outlined: "",
                          counter: "65500",
                          rows: "3",
                          label: "Descripción de la tarea",
                          hint:
                            "Describa la actividad que estará realizando en el data center. Tenga presente que si su solicitud no expone debidamente las tareas a ejecutar, no podrá ser procesada por nuestro Centro de Servicios",
                          rules: [
                            _vm.rules.required(_vm.isDoneByDayco),
                            _vm.rules.fieldMaxLengthOrEmpty(65500),
                            _vm.rules.specialCharacters()
                          ]
                        },
                        model: {
                          value: _vm.task.description,
                          callback: function($$v) {
                            _vm.$set(_vm.task, "description", $$v)
                          },
                          expression: "task.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-row", [_c("v-divider", { staticClass: "mt-2" })], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }